<div class="modal-header">
  <h5 class="modal-title">CONTACT SUPPORT</h5>
  <button type="button" class="btn-close btn-close-white" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="info-box">
    Complete the form below to send feedback and request sales and support assistance.
    <br />
    For support related information, please send an email to
    <a href="mailto:ProBenchmark.Support@isg-one.com">
      ProBenchmark.Support&#64;isg-one.com
    </a>
  </div>

  <form #contactForm="ngForm" (ngSubmit)="submit()">
    <div class="form-group">
      <label>First Name <span style="color:red" *ngIf="isFallback">*</span></label>
      <input type="text" [ngModel]="model.firstName" (ngModelChange)="model.firstName = $event; touchField()"
             name="firstName" class="form-control" [readonly]="!isFallback"
             [style.background-color]="isFallback ? '#fff' : null" />
    </div>

    <div class="form-group">
      <label>Last Name</label>
      <input type="text" [(ngModel)]="model.lastName" name="lastName" class="form-control"
             [readonly]="!isFallback" [style.background-color]="isFallback ? '#fff' : null" />
    </div>

    <div class="form-group">
      <label>Company <span style="color:red" *ngIf="isFallback">*</span></label>
      <input type="text" [ngModel]="model.company" (ngModelChange)="model.company = $event; touchField()"
             name="company" class="form-control" [readonly]="!isFallback"
             [style.background-color]="isFallback ? '#fff' : null" />
    </div>

    <div class="form-group" *ngIf="isFallback">
      <label>Email <span style="color:red">*</span></label>
      <input type="email" [ngModel]="model.email" (ngModelChange)="model.email = $event; touchField()"
             name="email" class="form-control" #emailCtrl="ngModel" email required
             [style.background-color]="'#fff'" />
      <span style="color: red; font-size: 13px;margin-left: 11px;" *ngIf="isSubmitted && (emailCtrl.errors?.required || emailCtrl.errors?.email)">Valid email is required</span>
    </div>

    <div class="form-group">
      <label>Comments <span style="color:red">*</span></label>
      <textarea [ngModel]="model.comments" (ngModelChange)="model.comments = $event; touchField()"
                name="comments" class="form-control" #commentsCtrl="ngModel"
                ngClass="{'is-invalid': isSubmitted && commentsCtrl.invalid}" required></textarea>
      <span style="color: red; font-size: 13px;margin-left: 11px;" *ngIf="isSubmitted &&(commentsCtrl.errors?.required)">Required</span>
    </div>

    <div class="text-center mt-3">
      <button type="submit" class="submit" [disabled]="!canSubmit() || isSaving()">SUBMIT</button>
    </div>
  </form>
  <isg-loader *ngIf="isSaving()"></isg-loader>
</div>
